/***
*
*   ONBOARDING LAYOUT
*   Simple layout to focus on user onboarding actions
*
**********/

import { useEffect } from 'react';
import Style from './onboarding.tailwind.js';

export function OnboardingLayout(props){

  useEffect(() => {

    document.body.classList.add('color');
    return () => { document.body.classList.remove('color'); }

  }, [])

  return (
    <main className={ Style.onboarding }style={{
      ...process.env.REACT_APP_SERVER === 'DEV' && { marginTop: '2.5rem' }
    }}>

      { <props.children {...props.data }/> }

    </main>
  );
}
